module.exports = __webpack_public_path__ + "img/APRL FOOLS SPCTACLES.8804305.svg";